  <template>
    <div class="md-layout">
      <div class="md-layout-item">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-green">
            <div class="card-icon">
              <md-icon>group</md-icon>
            </div>
            <h4 class="title">Parents</h4>
          </md-card-header>
          <md-card-content>
              <div class="md-layout">
                <div class="md-layout-item md-size-50">
                  <md-field>
                    <md-datepicker v-model="fromDate" md-immediately>
                      <label>From Date</label>
                    </md-datepicker>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-50">
                  <md-field>
                    <md-datepicker v-model="toDate" md-immediately>
                      <label>To Date</label>
                    </md-datepicker>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-50">
                  <md-field>
                    <md-input type="text" class="box-textbox" placeholder="Email" v-model="email"></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-50">
                  <md-field>
                    <label>Device Purchase Status</label>
                    <md-select v-model="devicePurchaseFilter">
                      <md-option value="">All</md-option>
                      <md-option value="Completed">Completed</md-option>
                      <md-option value="Incomplete">Incomplete</md-option>
                    </md-select>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-25">
                    <md-button class="md-primary" :disabled="isDisabled" @click="kidsParentsList()">Search</md-button> 
                </div>
            </div>
            <hr>
            <md-table
              :value="queriedData"
              :md-sort.sync="currentSort"
              :md-sort-order.sync="currentSortOrder"
              :md-sort-fn="customSort"
              class="paginated-table table-striped table-hover"
            >
              <md-table-toolbar>
                <md-field>
                  <label for="pages">Per page</label>
                  <md-select v-model="pagination.perPage" name="pages">
                    <md-option
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                      {{ item }}
                    </md-option>
                  </md-select>
                </md-field>
              </md-table-toolbar>

              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Name" md-sort-by="name">{{ item.name }}</md-table-cell>

                <md-table-cell md-label="Email" md-sort-by="email">
                  <a href="javascript:void(0)" @click="ByPassUserLogin(item.email)">{{ item.email }}</a>
                </md-table-cell>

                <md-table-cell md-label="Products">
                  {{ getProductNames(item.cartData) }}
                </md-table-cell>

                <md-table-cell md-label="Device Purchase Status">
                  <span
                    :class="[
                      'badge',
                      item.devicePurchaseStatus === 'Completed' ? 'badge-success' : 'badge-danger'
                    ]"
                  >
                    {{ item.devicePurchaseStatus }}
                  </span>
                </md-table-cell>

                <md-table-cell md-label="Created" md-sort-by="created_at">
                  {{ HumanReadableDateFormat(item.created_at, true) }}
                </md-table-cell>
              </md-table-row>


            </md-table>
            
          </md-card-content>
          <md-card-actions md-alignment="space-between">
            <div class="">
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
              </p>
            </div>
            <pagination
              class="pagination-no-border pagination-success"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </pagination>
          </md-card-actions>
        </md-card>
      </div>
    </div>
  </template>

  <script>
  import { Pagination } from "@/components";
  import Swal from "sweetalert2";
  import UsersDataService from "../../services/SuperAdmin/UsersDataService";

  export default {
    components: {
      Pagination,
    },
    computed: {
      /***
       * Returns a page from the searched data or the whole data. Search is performed in the watch section below
       */
      queriedData() {
        let result = this.tableData;

        // Apply status filter
        if (this.devicePurchaseFilter) {
          result = result.filter(
            (item) => item.devicePurchaseStatus === this.devicePurchaseFilter
          );
        }

        return result.slice(this.from, this.to);
      },

      to() {
        let highBound = this.from + this.pagination.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
      from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1);
      },
      total() {
        return this.searchedData.length > 0
          ? this.searchedData.length
          : this.tableData.length;
      },
    },
    data() {
      return {
        isDisabled: false,
        currentSort: "orderId",
        currentSortOrder: "asc",
        pagination: {
          perPage: 50,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0,
        },
        tableData: [],
        searchedData: [],
        email:"",
        fromDate: new Date(new Date().getFullYear(), 0, 1).toISOString().split('T')[0],
        toDate:null,
        devicePurchaseFilter: "",
      };
    },
    methods: {
      customSort(value) {
        return value.sort((a, b) => {
          const sortBy = this.currentSort;
          if (this.currentSortOrder === "desc") {
            return a[sortBy].localeCompare(b[sortBy]);
          }
          return b[sortBy].localeCompare(a[sortBy]);
        });
      },
      kidsParentsList() {
          let data = { fromDate: this.fromDate, toDate: this.toDate, email: this.email };
          UsersDataService.kidsParentsList(data)
            .then((response) => {
              this.tableData = response.data.data;
            })
            .catch((e) => {
              this.$toast.error(e.response.data.respones_msg);
            });
      },
      ByPassUserLogin(email) {
          let data = {
              email: email,
          }
          UsersDataService.ByPassUserLogin(data)
          .then((response) => {
              //localStorage.setItem('token', response.data.data.token);
              window.open("https://parent.mywingio.com?token="+response.data.data.token, '_blank');
          }).catch((e) => {
            this.$toast.error(e.response.data.respones_msg);
          });
      },
      getProductNames(cartData) {
        if (!cartData || !Array.isArray(cartData)) return "—";
        return cartData
          .map(c => c?.productDetail?.name || "Unknown Product")
          .join(", ");
      },

    },
    beforeMount() {
      this.kidsParentsList();
    },
    mounted() {
    },
    watch: {
      devicePurchaseFilter() {
        this.pagination.currentPage = 1;
      },
    },

  };
  </script>

  <style scoped>
  .md-card .md-card-actions {
    border: 0;
    margin-left: 20px;
    margin-right: 20px;
  }
  ::v-deep .md-table-cell {
    word-wrap: break-word;
    white-space: normal;
    vertical-align: top;
  }

  ::v-deep .md-table-cell[md-label="Email"],
  ::v-deep .md-table-cell[md-label="Order Status"] {
    min-width: 160px;
  }
  
  </style>
